import { IconButton, Paper, Stack, styled } from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { BodyTextM } from "../Typography";

export const InfoListPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        height: "100%",
        p: { md: 5, xs: 4 },
    }),
);

export const InfoListItemStack = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
}));

export const InfoListItemButton = styled(IconButton)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "flex-start",
        minWidth: "18px",
        height: "max-content",
        minHeight: "18px",
        px: theme.spacing(3),
        py: theme.spacing(0),
        my: "auto",
    }),
);

export const InfoListItemTitleStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        gap: theme.spacing(2),
        width: { xs: "100%", md: "50%" },
        pr: { md: theme.spacing(2) },
    }),
);

export const InfoListItemValueStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: { xs: "100%", md: "50%" },
    }),
);

export const InfoListItemAdditionalElementsStack = styled(Stack)(({ theme }) => theme.unstable_sx({}));

export const InfoListItemTitleBodyTextM = styled(
    BodyTextM,
    styledOmitPropsOptions,
)<{ $grow?: boolean }>(({ theme, $grow }) =>
    theme.unstable_sx({
        ...($grow && { flexGrow: 1 }),
    }),
);
